import React from 'react';
import { Button, Form, Input, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { FORM_NOT_EMPTY_RULE } from '../../../../../utils';
import { PaddedButton } from '../styles';
import { ERROR_MESSAGES, LAYOUT_STYLES, TAIL_STYLES } from '../constants';

const FUBO_USER_ID_REGEX = /^[a-zA-Z0-9]+$/;

const FuboForm = ({ onSubmit, onBack }) => {
  return (
    <Form {...LAYOUT_STYLES} onFinish={onSubmit}>
      <Form.Item
        label="Fubo User ID"
        name="fuboUserId"
        rules={[
          { required: true, message: ERROR_MESSAGES.REQUIRED_FUBO_USER_ID },
          {
            pattern: FUBO_USER_ID_REGEX,
            message: ERROR_MESSAGES.INVALID_FUBO_USER_ID,
          },
          FORM_NOT_EMPTY_RULE,
        ]}
        tooltip={{
          title: 'Fubo User ID can only contain letters and numbers',
          icon: <InfoCircleOutlined />,
        }}
      >
        <Input placeholder="e.g., 123f123456789f000001a2b3" />
      </Form.Item>
      <Form.Item
        label={
          <span>
            Nickname&nbsp;
            <Tooltip title="Customize Profile Nickname: Links to your Profile, not the Account">
              <InfoCircleOutlined />
            </Tooltip>
          </span>
        }
        name="nickname"
        rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_NICKNAME }, FORM_NOT_EMPTY_RULE]}
      >
        <Input />
      </Form.Item>
      <Form.Item {...TAIL_STYLES}>
        <Button onClick={onBack}>Back</Button>
        <PaddedButton type="primary" htmlType="submit">
          Submit
        </PaddedButton>
      </Form.Item>
    </Form>
  );
};

export default FuboForm;
